var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"student-amount"}},[_c('h1',{staticClass:"current-amount"},[_vm._v("Amount of students checked in: "+_vm._s(_vm.particleAmount / 10))])])}
var staticRenderFns = []

export { render, staticRenderFns }